/**
 * Collection Showcase Premium.
 * Card hover, center-image hover and the fade-up reveal are pure CSS.
 *
 * JS has two responsibilities:
 * 1. Fit the background word so it spans edge-to-edge across the showcase
 *    stage at any screen width and for any word/font choice — CSS alone
 *    cannot measure rendered text width, so it's measured here and turned
 *    into a transform scale (recalculated on resize and after web fonts
 *    load, so it never clips or gets cut off on any device).
 * 2. Trigger the fade-up reveal once the section scrolls into view.
 */
(function () {
  'use strict';

  function fitWord(section) {
    var stage = section.querySelector('[data-csp-stage]');
    var word = section.querySelector('[data-csp-word]');
    if (!stage || !word) return;

    var naturalWidth = word.scrollWidth;
    if (!naturalWidth) return;

    var margin = window.innerWidth <= 749 ? 0.92 : 0.96;
    var availableWidth = stage.clientWidth * margin;
    var scale = availableWidth / naturalWidth;

    word.style.setProperty('--csp-word-fit-scale', scale);
  }

  function reveal(section) {
    section.querySelectorAll('[data-csp-reveal]').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-csp-section]').forEach(function (section) {
      if (section._cspInit) return;
      section._cspInit = true;

      fitWord(section);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { fitWord(section); });
      }

      var resizeTimer;
      var onResize = function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { fitWord(section); }, 120);
      };

      if ('ResizeObserver' in window) {
        var stage = section.querySelector('[data-csp-stage]');
        if (stage) new ResizeObserver(onResize).observe(stage);
      } else {
        window.addEventListener('resize', onResize);
      }

      if (section.dataset.animate === 'false' || !('IntersectionObserver' in window)) {
        reveal(section);
        return;
      }

      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(section);
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

      revealObserver.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();